<template>
  <div :style="{ 'height': height }">
    <div>
      <el-input v-model="name" @input="nameBlur" placeholder="搜索模版名称" size="small" prefix-icon="el-icon-search" width="100%">
      </el-input>
    </div>
    <el-collapse v-model="activeName" :disabled="disabled" :accordion="accordion" :style="{borderTop: 'none'}">
      <el-collapse-item v-for="item in tableData" :key="item[nodeKey.text]" :name="item[nodeKey.text]">
        <template slot="title">
          <span class="gj-pl20"></span>{{ item[nodeKey.text] }}
        </template>
        <div class="margin_left_36 column_sta">
          <div :class="[{ 'collapse-content-active': items.isActive }, {'curnot': disabled}, 'collapse-content', 'text-ellipsis-1']"
            v-for="items in item[nodeKey.children]" :key="items[nodeKey.id]"
            @click="select(nodeKey.children, items)">
            {{ items[nodeKey.text] }}
            <i v-if="items.isActive" class="el-icon-check"></i>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { queryMailTemplateVariable, templateList } from "@/api/crm";
export default ({
  name: 'gj-cascader-select',
  props: {
    height: {
      type: String,
      default: '500px'
    },
    countryList: Array,
    marketIdList: Array,
    // 是否可以多选
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否可以查询
    filterable: {
      type: Boolean,
      default: false
    },
    // 手风琴效果
    accordion: {
      type: Boolean,
      default: false
    },
    isInit:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeName: null,
      activeItem: null,
      tableData: [],
      name: "",
      nodeKey: {
        id: 'variableValue',
        text: 'variableText',
        children: 'mailTemplateVariableList',
      },
    }
  },
  created() {
    this.nodeKey = {
      id: 'id',
      text: 'name',
      children: 'marketMailTemplateVOList',
    }
    this.templateListQuery();
  },
  methods: {
    select(key, item) {
      if(this.disabled) {
        return false
      }
      this.tableData.forEach(data => {
        data[key].forEach(datas => {
          datas.isActive = false
        })
      })
      item.isActive = true;
      this.activeItem = item
      this.$emit("templateRow", item);
    },
    templateListQuery() {
      templateList({
          countryCodeList: this.countryList,
          marketIdList: this.marketIdList,
          name: this.name
        }).then((data => {
        data.forEach(item => {
          item.name = item.templateType;
          item.marketMailTemplateVOList.forEach(items => {
            if(this.activeItem && this.activeItem.id === items.id) {
              items.isActive = true;
            }else {
              items.isActive = false;
            }
          })
        });
        if(!this.activeItem && data.length > 0 && data[0].marketMailTemplateVOList.length > 0 && this.isInit) {
          data[0].marketMailTemplateVOList[0].isActive = true
          this.activeName = data[0].name
          this.activeItem = data[0].marketMailTemplateVOList[0]
          this.$emit("templateRow", this.activeItem);
        }
        this.tableData = data;
      }))
    },
    nameBlur() {
      if (this.name) {
        this.tableData = [];
        this.templateListQuery();
      }
    }
  },
  watch: {
    countryList: {
      handler() {
        this.templateListQuery();
      }
    },
    marketIdList: {
      handler() {
        this.templateListQuery();
      }
    }
  }
})
</script>

<style lang="scss">
.gj-cascader-select {
  .title {
    height: 31px;
    border-top: 1px solid #D8DADD;
    border-left: 1px solid #D8DADD;
    border-right: 1px solid #D8DADD;
    line-height: 31px;
    padding-left: 12px;
    background: #F6F7F8;
  }

  .el-icon-search {
    font-size: 18px
  }

  .el-collapse {
    background: #fff;
    overflow-Y: auto;
    height: 326px;
    border: 1px solid #D8DADD;
    font-size: 12px;

    .el-collapse-item {
      position: relative;
      .el-collapse-item__content {
        padding-bottom: 0
      }
    }

    .el-collapse-item__header {
      height: 38px;
      line-height: 38px;
      border-bottom: 1px solid #D8DADD;
      padding-left: 10px;

      &.is-active {
        border-bottom: 1px solid #D8DADD;
      }

      .margin_0_10 {
        margin: 0 10px;
      }

      .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
      }
    }

    .el-collapse-item__wrap {
      border-bottom: 1px solid #D8DADD;
    }



    .el-button {
      margin-left: 0;
    }
  }

  .column_sta {
    .collapse-content {
      height: 38px;
      line-height: 38px;
      border-bottom: 1px solid #D8DADD;
      padding: 0 31px;
      color: #666666;
      cursor: pointer;

      .el-icon-check {
        float: right;
        margin-top: 12px;
        font-size: 15px;
      }
    }

    .curnot{
      cursor:not-allowed;
    }

    .collapse-content-active {
      color: #1F6EEF;
      background: #EEF3FB;

      .el-icon-check {
        color: #1F6EEF;
      }
    }

    :last-child {
      border-bottom: 0 !important;
    }
  }
}
</style>
